<template>
  <div>
    <ImportContactsTabs @openConfirmationModal="openConfirmationModal" />
    <CCard>
      <CCardHeader>
        <span class="font-weight-bold font-xl">{{ stepTitle }}</span>
      </CCardHeader>
      <CCardBody class="p-5 mt-2 min-h-590 d-flex flex-column">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
        <transition name="fade" v-if="showConfirmationModal">
          <div class="dataTable__popUp popUp centralize-popup" @click.stop.stop>
            <div class="popUp__body shadow-sm">
              <ConfirmationDelete
                :title="confirmationModalTitle"
                :description="confirmationModalDescription"
                :customStyleModal="customStyleModal"
                :customStyleConfirmActions="customStyleConfirmActions"
                :confirmText="confirmationModalConfirmText"
                :cancelText="confirmationModalCancelText"
                @confirm="handleConfirmConfirmationModal"
                @cancel="closeConfirmationModal"
              />
            </div>
          </div>
        </transition>

        <div class="d-flex flex-column justify-content-between flex-grow-1" :class="{ 'disable-form': showConfirmationModal }">
          <div v-show="isCurrentStep(IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS)">
            <ConfigImportFile v-if="isUploadImport" ref="configImportStepRef" @addMessage="addMessage" @changeLoadingStep="handleLoadingStep" />
            <ConfigImportManual v-else="isUploadImport" ref="configImportStepRef" @addMessage="addMessage" @changeLoadingStep="handleLoadingStep" />
          </div>
          <MatchColumns v-show="isCurrentStep(IMPORT_CONTACTS_STEPS.MATCH_COLUMNS)" @addMessage="addMessage" />
          <CreateAudience
            ref="createAudienceStepRef"
            v-show="isCurrentStep(IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE)"
            :isStepVisible="isCurrentStep(IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE)"
            @addMessage="addMessage"
            @changeLoadingStep="handleLoadingStep"
          />
          <div v-if="!importSuccess" class="d-flex justify-content-end">
            <CButton class="btn-outline-gray-500 px-5 py-3 mr-2 w-165" :disabled="isLoadingStep" @click="openConfirmationModal">
              {{ $t('audience-new.import-contacts.cancel') }}
            </CButton>
            <CButton
              color="primary"
              :disabled="!isStepValid($store.state.audience.importContacts.currentStep) || isLoadingStep"
              :loading="isLoadingStep"
              @click="handleNextStep"
              class="py-2 w-165"
            >
              <span>
                {{
                  isCurrentStep(IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE)
                    ? $t('audience-new.import-contacts.go-to-import-results')
                    : $t('audience-new.import-contacts.continue')
                }}
              </span>
              <CSpinner class="ml-2" v-if="isLoadingStep" color="primary" style="width: 1rem; height: 1rem" />
            </CButton>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import ImportContactsTabs from '../../components/import/ImportContactsTabs.vue'
import ConfirmationDelete from '@/components/ConfirmationDelete'
import MenssageAlert from '@/components/MenssageAlert'
import { IMPORT_CONTACTS_STEPS } from '../../constants'
import MatchColumns from './steps/MatchColumns.vue'
import CreateAudience from './steps/CreateAudience.vue'
import { mapGetters } from 'vuex'
import ConfigImportFile from './steps/ConfigImportFile.vue'
import ConfigImportManual from './steps/ConfigImportManual.vue'

export default {
  name: 'ImportContacts',
  components: { ImportContactsTabs, ConfigImportFile, ConfigImportManual, MatchColumns, CreateAudience, ConfirmationDelete, MenssageAlert },
  data() {
    return {
      IMPORT_CONTACTS_STEPS,
      showConfirmationModal: false,
      customStyleModal: 'width: 550px',
      customStyleConfirmActions: 'text-align: end',
      confirmationModalTitle: undefined,
      confirmationModalDescription: undefined,
      confirmationModalConfirmText: undefined,
      confirmationModalCancelText: undefined,
      isConfirmationModalBack: false,
      messages: [],
      isLoadingStep: false,
    }
  },
  computed: {
    ...mapGetters({
      isStepValid: 'audience/isStepValid',
    }),

    isUploadImport() {
      return this.$route.params.type === 'upload'
    },

    stepTitle() {
      const stepTitleMap = {
        [IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS]: 'audience-new.config-import.title',
        [IMPORT_CONTACTS_STEPS.MATCH_COLUMNS]: 'audience-new.match-columns.title',
        [IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE]: 'audience-new.create-audience.title',
      }

      const matchedStepTranslation = stepTitleMap[this.$store.state.audience.importContacts.currentStep]

      return this.$t(matchedStepTranslation)
    },

    organizationId() {
      return this.$route.params.organizationId
    },

    importSuccess() {
      return this.$store.state.audience.importContacts.importSuccess
    },
  },
  methods: {
    isCurrentStep(step) {
      return this.$store.state.audience.importContacts.currentStep === step
    },

    async handleNextStep() {
      const { completedSteps, currentStep } = this.$store.state.audience.importContacts

      if (currentStep === IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS) {
        await this.$refs.configImportStepRef.sendFile()
      }

      if (currentStep === IMPORT_CONTACTS_STEPS.MATCH_COLUMNS) {
        this.$store.dispatch('audience/setImportContactsCompletedSteps', [...completedSteps, currentStep])
        this.$store.dispatch('audience/setImportContactsStep', IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE)
      }

      if (currentStep === IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE) {
        await this.$refs.createAudienceStepRef.sendForImport()
      }
    },

    openConfirmationModal(step) {
      if (step && step === IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS) {
        this.confirmationModalTitle = `<p class='font-xl text-black font-weight-bold'>${this.$t(
          'audience-new.import-contacts.confirmation-modal.back-title',
        )}<p>`
        this.confirmationModalDescription = this.$t('audience-new.import-contacts.confirmation-modal.back-description')
        this.confirmationModalConfirmText = this.$t('audience-new.import-contacts.confirmation-modal.back-confirmText')
        this.confirmationModalCancelText = this.$t('audience-new.import-contacts.confirmation-modal.back-cancelText')
        this.isConfirmationModalBack = true
      } else {
        this.confirmationModalTitle = `<p class='font-xl text-black font-weight-bold'>${this.$t(
          'audience-new.import-contacts.confirmation-modal.cancel-title',
        )}<p>`
        this.confirmationModalDescription = this.$t('audience-new.import-contacts.confirmation-modal.cancel-description')
        this.confirmationModalConfirmText = this.$t('audience-new.import-contacts.confirmation-modal.cancel-confirmText')
        this.confirmationModalCancelText = this.$t('audience-new.import-contacts.confirmation-modal.cancel-cancelText')
        this.isConfirmationModalBack = false
      }
      this.showConfirmationModal = true
    },

    closeConfirmationModal() {
      this.showConfirmationModal = false
    },

    async handleConfirmConfirmationModal() {
      this.showConfirmationModal = false
      if (!this.isConfirmationModalBack) {
        await this.$router.push({ name: 'choose-methods' })
      }

      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$store.dispatch('audience/clearImportContactsState', IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS)
    },

    addMessage(message) {
      this.messages = [message]
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    handleLoadingStep(value) {
      this.isLoadingStep = value
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch('audience/clearImportContactsState', IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS)
    })
  },
}
</script>

<style lang="scss" scoped>
.centralize-popup {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: var(--danger);
}

.disable-form {
  filter: blur(1px);
  pointer-events: none;
}

.min-h-590 {
  min-height: 590px;
}

.w-165 {
  width: 165px;
}
</style>
